import React from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import NewsletterContent from './NewsletterContent'
import { actionsType } from 'config/constants';
import style from './style.scss';//NOSONAR

const Newsletter = () => {

    const closeNewsletter = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.NEWSLETTER_CLOSE),0);
    }

    return (
        <Modal customClass='modal-newsletter' actionOpen={actionsType.MODAL.NEWSLETTER_OPEN} actionClose={actionsType.MODAL.NEWSLETTER_CLOSE}>
            <NewsletterContent closeNewsletter={closeNewsletter}/>
        </Modal>
    );
}

export default Newsletter;
